/* eslint-disable no-param-reassign */
import { getSearchObj } from '@tencent/magic-ui-util';
import { YYB_APP_IDS } from '../../../src/constant/index';

const location = window.location.href === 'about:blank' ? window.parent.location : window.location;
const params = getSearchObj(location.search);
export default {
  name: 'style',
  items: [{
    type: 'fieldset',
    text: '大小',
    labelWidth: '80px',
    items: [{
      type: 'row',
      items: [{
        name: 'isSizeUsePercent',
        type: 'switch',
        activeValue: true,
        inactiveValue: false,
        text: '用百分比',
        tip: '打开时，保存活动配置时，将会把宽度和高度根据当前数值和页面实际宽高换算成百分比',
      }],
    }, {
      type: 'row',
      items: [{
        name: 'width',
        text: '宽度',
        onChange(vm, value, { values, model }) {
          // 没有使用固定长宽比
          if (!(values.devconfig && values.devconfig.aspectRatio)) {
            return;
          }

          // 固定长宽比的情况不处理百分比
          if (/%/.test(value)) {
            return;
          }
          model.height = value * values.devconfig.ratio;
        },
        disabled: (vm, { model }) => {
          if (YYB_APP_IDS.indexOf(params.appId?.toString()) > -1
          && !!model.backgroundImage) {
            return true;
          }
          return false;
        },
      }, {
        name: 'height',
        text: '高度',
        onChange(vm, value, { values, model }) {
          // 没有使用固定长宽比
          if (!(values.devconfig && values.devconfig.aspectRatio)) {
            return;
          }

          // 固定长宽比的情况不处理百分比
          if (/%/.test(value)) {
            return;
          }
          model.width = value / values.devconfig.ratio;
        },
        disabled: (vm, { model }) => {
          if (YYB_APP_IDS.indexOf(params.appId?.toString()) > -1
          && !!model.backgroundImage) {
            return true;
          }
          return false;
        },
      }],
    }],
  }, {
    type: 'fieldset',
    text: '位置',
    labelWidth: '80px',
    display: (vm, { model }) => ['absolute', 'fixed'].includes(model.position),
    items: [{
      type: 'row',
      items: [{
        name: 'position',
        type: 'switch',
        activeValue: 'fixed',
        inactiveValue: 'absolute',
        text: '固定定位',
      }],
    }, {
      type: 'row',
      items: [{
        name: '_horizontal_center',
        type: 'switch',
        activeValue: true,
        inactiveValue: false,
        text: '水平居中',
        display: (vm, { model }) => model.position === 'absolute',
      }, {
        type: 'row',
        items: [{
          name: '_vertical_center',
          type: 'switch',
          activeValue: true,
          inactiveValue: false,
          text: '垂直居中',
          tip: '相对于父组件而言',
          display: (vm, { model }) => model.position === 'absolute',
        }],
      }],
    }, {
      type: 'row',
      items: [
        {
          name: 'isPositionUsePercent',
          type: 'switch',
          activeValue: true,
          inactiveValue: false,
          text: '用百分比',
          tip: '打开时，保存活动配置时，将会把left,top,right,bottom根据当前数值和页面实际宽高换算成百分比',
          display: (vm, { model }) => model.position === 'absolute',
        }],
    }, {
      type: 'row',
      display: (vm, { model }) => model.position === 'fixed',
      items: [{
        name: '_magic_position',
        text: '快捷定位',
        type: 'select',
        onChange(vm, value, { model }) {
          model.position = 'fixed';
          if (value === 'fixedTop') {
            vm.$set(model, 'top', 0);
            vm.$set(model, 'bottom', '');
          }
          if (value === 'fixedBottom') {
            vm.$set(model, 'top', '');
            vm.$set(model, 'bottom', 0);
          }
          if (value === 'fixedLeft' || value === 'fixedRight') {
            if (value === 'fixedLeft') {
              vm.$set(model, 'left', 0);
              vm.$set(model, 'right', '');
            } else {
              vm.$set(model, 'left', '');
              vm.$set(model, 'right', 0);
            }
            const tips = model.fixed_max_width ? `${model.fixed_max_width}px` : '100%';
            vm.$set(model, 'fixed_describe', `通常在PC场景，挂件浮动在不超过${tips}的屏幕中间区域最${value === 'fixedLeft' ? '左' : '右'}侧`);
          }
        },
        options: [
          { value: 'fixedTop', text: '吸顶' },
          { value: 'fixedBottom', text: '吸底' },
          { value: 'fixedLeft', text: '吸左' },
          { value: 'fixedRight', text: '吸右' },
        ],
      }, {
        name: 'fixed_max_width',
        text: '最大宽度',
        onChange(vm, value, { model }) {
          const tips = value ? `${value}px` : '100%';
          // eslint-disable-next-line no-underscore-dangle
          vm.$set(model, 'fixed_describe', `通常在PC场景，挂件浮动在不超过${tips}的屏幕中间区域最${model._magic_position === 'fixedLeft' ? '左' : '右'}侧`);
        },
        // eslint-disable-next-line no-underscore-dangle
        display: (vm, { model }) => model.position === 'fixed' && ['fixedLeft', 'fixedRight'].indexOf(model._magic_position) > -1,
      }],
    }, {
      type: 'row',
      items: [{
        name: 'fixed_describe',
        text: ' ',
        type: 'display',
        // eslint-disable-next-line no-underscore-dangle
        display: (vm, { model }) => model.position === 'fixed' && ['fixedLeft', 'fixedRight'].indexOf(model._magic_position) > -1,
      }],
    }, {
      type: 'row',
      display: (vm, { model }) => model.position === 'fixed',
      items: [{
        name: '_magic_visible',
        text: '显示时机',
        type: 'select',
        onChange: (vm, value, { formValue }) => {
          if (value === 'scroll' && !formValue.renderType) {
            formValue.renderType = 1;
          }
        },
        options: [
          { value: 'always', text: '一直显示' },
          { value: 'scroll', text: '滚动显示' },
        ],
      }, {
        name: '_magic_visible_top',
        text: '显示高度',
        /* eslint-disable no-underscore-dangle */
        display: (vm, { model }) => model.position === 'fixed' && model._magic_visible === 'scroll',
      }],
    }, {
      type: 'row',
      items: [{
        name: 'left',
        text: 'left',
        disabled: (vm, { model }) => model.position === 'fixed' && model._magic_position === 'fixedRight',
      }, {
        name: 'top',
        text: 'top',
        disabled: (vm, { model }) => model.position === 'fixed' && model._magic_position === 'fixedBottom',
      }],
    }, {
      type: 'row',
      items: [{
        name: 'right',
        text: 'right',
        disabled: (vm, { model }) => model.position === 'fixed' && model._magic_position === 'fixedLeft',
      }, {
        name: 'bottom',
        text: 'bottom',
        disabled: (vm, { model }) => model.position === 'fixed' && model._magic_position === 'fixedTop',
      }],
    }, {
      type: 'row',
      items: [{
        name: 'zIndex',
        text: 'z-index',
        defaultValue: 'auto',
      }],
    }],
  }],
};
